import React from "react";

function UploadPRX() {
  return <div>UploadPRX</div>;
}

export default UploadPRX;
